export default function Success() {
	return (
		<svg width="14" height="15" viewBox="0 0 14 15" fill="none" className="toast__icon">
			<g>
				<circle cx="7" cy="7.5" r="7" fill="white" />
				<g>
					<g>
						<path
							d="M4.04639 7.41678L6.23498 10.0806L10.5535 5.2002"
							stroke="#404040"
							strokeWidth="1.5"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</g>
				</g>
			</g>
		</svg>
	);
}
